import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../types/Cashier';
import ComposedBonusMessage from '../ComposedBonusMessage/ComposedBonusMessage';
import SeeDetailsLink from '../SeeDetailsLink/SeeDetailsLink';

import { TXTCLI_The_maximum_bonus_that_can_be__ELL_1 } from './StandardCashReleaseBonus.messages.json';
import QualifyDeposits from './components/QualifyDeposits/QualifyDeposits';

const StandardCashReleaseBonus: React.FC = () => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const { balanceAmount, bonusMax, bonusCurrency, potentialBonusAmount, maxNumberOfDepositsLeft } =
    preCashinInfo as PreCashinInfo;

  return (
    <>
      <ComposedBonusMessage isFirst={false} amount={balanceAmount} bonus={potentialBonusAmount} />
      {maxNumberOfDepositsLeft && (
        <>
          <Translation
            tagName="p"
            {...TXTCLI_The_maximum_bonus_that_can_be__ELL_1}
            values={{
              0: <CurrencyAmount value={bonusMax} currency={bonusCurrency} />
            }}
          />
          <QualifyDeposits />
        </>
      )}
      <SeeDetailsLink />
    </>
  );
};

export default StandardCashReleaseBonus;
